module.exports = __webpack_public_path__ + "img/1696904556352-1696382580003-NIB ANANDA JELITA.png.webp.0a6e7808.webp";